module.exports = __webpack_public_path__ + "img/TL.af5ad001.svg";